import React from 'react';

const LoadingButton = ({
  buttonDisable,
  isLoading,
  type = 'button',
  className = '',
  children,
  ...props
}) => {
  return (
    <button
      className={`btn update-plan-btn ${className}`}
      type={type}
      disabled={buttonDisable}
      {...props}
    >
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
